export default [
	{
		country: 'CA',
		username: 'alsidua',
		url: 'https://www.reddit.com/user/alsidua'
	},
	{
		country: 'CA',
		username: 'olsbounty',
		url: 'https://www.reddit.com/user/olsbounty'
	},
	{
		country: 'CA',
		username: 'svetlanamajkl',
		url: 'https://www.reddit.com/user/svetlanamajkl'
	},
	{
		country: 'DE',
		username: 'oolegov',
		url: 'https://www.reddit.com/user/oolegov'
	},
	{
		country: 'DE',
		username: 'olslo',
		url: 'https://www.reddit.com/user/olslo'
	},
	{
		country: 'RU',
		username: 'olovby',
		url: 'https://www.reddit.com/user/olovby'
	},
	{
		country: 'RU',
		username: 'cryptostockexchange',
		url: 'https://www.reddit.com/user/cryptostockexchange'
	}
]